import React from "react"
import {Mic , MicOff, Smartphone} from "react-feather"
import {
  Badge,
  Button,
  Row,
  UncontrolledTooltip
} from "reactstrap"
import userImg from "../../../assets/img/portrait/small/avatar-s-11.jpg";
import "../../../assets/scss/pages/app-chat.scss"; 

class Participant extends React.Component {
  state = {
    activeIndex: 0
  }

  render() {
    const { participant } = this.props
    const { audio, displayName, imageUrl, status} = participant;
    const {isOpted, isMute} = audio;
    
    return (
      <li
        onClick={() => {
          /*this.props.handleActiveChat(chat.uid, chat, activeID)
          this.props.mainSidebar(false)
          this.props.markSeenAllMessages(chat.uid)*/
        }}>
        <div className="pr-1 mt-13-">
          <span className="avatar avatar-md m-0">
            <img
              src={userImg}
              alt="Participant1"
              height="38"
              width="38"
            />
            <span
              className={`
            ${
              status === "OFFLINE"
                ? "avatar-status-offline"
                : status === "ONLINE"
                ? "avatar-status-online"
                : "avatar-status-away"
            }
            `}
            />
          </span>
        </div>
        <div className="user-chat-info">
          <div className="contact-info mtop-5">
            <h5 id="display-name" className="text-bold-600 mb-0 ellipsis">{participant.displayName}</h5>
            <UncontrolledTooltip placement="top" target="display-name">
              {participant.displayName}
            </UncontrolledTooltip>
            <p className="truncate">
              {status}
            </p>
          </div>
          <div className="contact-meta d-flex- flex-column margin-auto">
            <div className="unseen-msg display-inline">
                <Badge
                  className="badge-md float-right"
                  color="primary"
                  pill
                >
                  {isMute ? <MicOff size={16} /> : <Mic size={16} />}
                  
                </Badge>
            </div>
            <span className="float-right mr-25 mb-25">
              <Smartphone id="device" size={25} className="display-inline"/>
              <UncontrolledTooltip placement="top" target="device">
                    iPhone 11
              </UncontrolledTooltip>
            </span>
          </div>
        </div>
      </li>
    )
  }
}
export default Participant;